(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const addRevealGroup = (home, selector, variant, interval = 70) => {
    home.querySelectorAll(selector).forEach((element, index) => {
      if (element.hasAttribute('data-dp-reveal')) return;
      const resolvedVariant = typeof variant === 'function' ? variant(index, element) : variant;
      element.setAttribute('data-dp-reveal', resolvedVariant || 'up');
      element.style.setProperty('--dp-reveal-delay', `${Math.min(index * interval, 280)}ms`);
    });
  };

  const initialize = (scope = document) => {
    const homes = scope.matches?.('.decopar-home')
      ? [scope]
      : Array.from(scope.querySelectorAll?.('.decopar-home') || []);

    homes.forEach((home) => {
      if (home.dataset.scrollRevealReady === 'true') return;
      home.dataset.scrollRevealReady = 'true';

      addRevealGroup(home, '.dp-intro__grid > *', 'up', 90);
      addRevealGroup(home, '.dp-collections-heading > *', 'up', 80);
      addRevealGroup(home, '.dp-collection-card', (index) => (index % 2 === 0 ? 'left' : 'right'), 85);

      addRevealGroup(
        home,
        '#muebles .dp-section-heading > *, #revestimientos .dp-section-heading > *, #proyectos .dp-section-heading > *',
        'up',
        70
      );
      addRevealGroup(home, '.dp-card--furniture, .dp-card--covering, .dp-card--project', 'media', 75);

      addRevealGroup(home, '.dp-service__media', 'left');
      addRevealGroup(home, '.dp-service__content > .dp-section-label, .dp-service__content > h2, .dp-service__lead', 'right', 80);
      addRevealGroup(home, '.dp-process__item', 'up', 80);
      addRevealGroup(home, '.dp-service__content > .dp-button-row', 'up');

      addRevealGroup(home, '.dp-showroom__media', 'right');
      addRevealGroup(home, '.dp-showroom__content > *', 'left', 75);

      addRevealGroup(home, '.dp-instagram-heading', 'up');
      addRevealGroup(home, '.dp-instagram > a', 'media', 55);

      home.classList.add('dp-scroll-reveal-enabled');

      const elements = home.querySelectorAll('[data-dp-reveal]');
      if (reducedMotion.matches || !('IntersectionObserver' in window)) {
        elements.forEach((element) => element.classList.add('is-revealed'));
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          });
        },
        {
          threshold: 0.12,
          rootMargin: '0px 0px -7% 0px',
        }
      );

      elements.forEach((element) => observer.observe(element));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
